import useUrl from 'hooks/useUrl';
import {
  intervalsHash,
  defaultCurrentService,
  defaultSelectedInterval,
  integrationsHash,
} from '@constants';

const useGeneralIntegrationPageContext = () => {
  const { queryInterval, queryTargetService } = useUrl();
  const intervalToUse = intervalsHash[queryInterval] || defaultSelectedInterval;

  const targetService = queryTargetService;

  const selectedIntegration = integrationsHash[targetService];

  return { intervalToUse, targetService, selectedIntegration };
};

export default useGeneralIntegrationPageContext;
